import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { CustomProvider } from 'rsuite';
import { esES } from 'rsuite/esm/locales';

import App from './App';

import registerServiceWorker from './registerServiceWorker';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

const root = ReactDOM.createRoot(rootElement);

root.render(<BrowserRouter basename={baseUrl}><CustomProvider locale={esES}><App /></CustomProvider></BrowserRouter>);

registerServiceWorker();

